import { Navigate, Outlet, useLocation } from 'react-router';
import { useMe } from '../api/auth';
import { Spinner } from '../components/ui/spinner';
import { ImportDialog } from '../features/import/import-dialog';
import { EditLabelsDialog } from '../features/labels/edit-labels-dialog';
import { NoteEditorRoute } from '../features/notes/note-editor';
import { SettingsDialog } from '../features/settings/settings-dialog';
import { useKeyboardShortcuts } from '../hooks/use-keyboard-shortcuts';
import { useReminderNotifications } from '../hooks/use-reminder-notifications';
import { useServerEvents } from '../hooks/use-server-events';
import { paths } from '../lib/routes';
import { Header } from './header';
import { Sidebar } from './sidebar';

function AuthenticatedShell() {
  useServerEvents(true);
  useReminderNotifications();
  useKeyboardShortcuts();

  return (
    <div className="min-h-full">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="min-w-0 flex-1 px-2 pb-24 sm:px-4">
          <Outlet />
        </main>
      </div>
      <NoteEditorRoute />
      <EditLabelsDialog />
      <SettingsDialog />
      <ImportDialog />
    </div>
  );
}

/** Garde d'authentification : redirige vers la connexion si aucune session. */
export function AppLayout() {
  const { data: user, isPending, isError, refetch } = useMe();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="size-8" />
      </div>
    );
  }
  if (isError) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 text-muted">
        <p>Impossible de joindre le serveur.</p>
        <button
          type="button"
          className="rounded px-4 py-2 text-primary hover:bg-hover"
          onClick={() => refetch()}
        >
          Réessayer
        </button>
      </div>
    );
  }
  if (!user) {
    const from = location.pathname + location.search;
    return <Navigate to={paths.login} replace state={{ from }} />;
  }
  return <AuthenticatedShell />;
}
